import { type RecipeComment } from '../../api/Types';

export const getCommentsErrorMessage = (error: unknown): string =>
  error instanceof Error ? error.message : 'Failed to load comments.';

export const listCommentAuthorIds = (comments: RecipeComment[]): number[] =>
  Array.from(
    new Set(
      comments
        .map((comment) => comment.author?.id)
        .filter((authorId): authorId is number => Boolean(authorId))
    )
  );

export const mergeUpdatedAuthor = (
  comment: RecipeComment,
  author: {
    id: number;
    name: string;
    first_name: string;
    avatar_url: string;
    color: string;
    created_at: string;
  }
): RecipeComment =>
  comment.author?.id === author.id
    ? {
        ...comment,
        author: {
          ...comment.author,
          id: author.id,
          name: author.name,
          first_name: author.first_name,
          avatar_url: author.avatar_url,
          color: author.color,
          created_at: author.created_at,
        },
      }
    : comment;

export const appendCommentIfMissing = (
  comments: RecipeComment[],
  newComment: RecipeComment
): RecipeComment[] =>
  comments.some((comment) => comment.id === newComment.id)
    ? comments
    : [...comments, newComment];

export const replaceCommentById = (
  comments: RecipeComment[],
  commentId: number,
  updatedComment: RecipeComment
): RecipeComment[] =>
  comments.map((comment) => (comment.id === commentId ? updatedComment : comment));

export const removeCommentById = (comments: RecipeComment[], commentId: number): RecipeComment[] =>
  comments.filter((comment) => comment.id !== commentId);

export const handleRealtimeCommentLoadError = (action: 'new' | 'updated', error: unknown) => {
  console.error(`Error fetching author for ${action} comment:`, error);
};

export const handleMissingRealtimeComment = (
  action: 'new' | 'updated',
  comment: RecipeComment
) => {
  console.error(`Author not found for ${action} comment:`, comment);
};
